// Simple structured logger for PWA-Handel
// Logs are sent to console with structured data for easy parsing

interface LogContext {
  [key: string]: any;
  trace_id?: string;
  browser?: string;
  user_id?: string;
}

type LogLevel = 'info' | 'warn' | 'error';

class Logger {
  private detectBrowser(): string {
    const ua = navigator.userAgent;
    if (ua.includes('Chrome')) return 'Chrome';
    if (ua.includes('Safari')) return 'Safari';
    if (ua.includes('Firefox')) return 'Firefox';
    if (ua.includes('Edge')) return 'Edge';
    return 'Unknown';
  }

  private log(level: LogLevel, message: string, context?: LogContext) {
    const timestamp = new Date().toISOString();
    const browser = this.detectBrowser();
    const url = window.location.href;

    const logData = {
      timestamp,
      level,
      message,
      browser,
      url,
      ...context,
    };

    // Console output with color
    const colors = {
      info: 'color: #3b82f6',
      warn: 'color: #f59e0b',
      error: 'color: #ef4444',
    };

    console.log(
      `%c[${timestamp}] [${browser}] ${level.toUpperCase()}: ${message}`,
      colors[level],
      logData
    );

    // TODO: Send to external logging service (e.g., Sentry, LogRocket)
    // if (level === 'error') {
    //   sendToExternalLogger(logData);
    // }
  }

  debug(message: string, context?: LogContext) {
    this.log('info', message, context);
  }

  info(message: string, context?: LogContext) {
    this.log('info', message, context);
  }

  warn(message: string, context?: LogContext) {
    this.log('warn', message, context);
  }

  error(message: string, context?: LogContext) {
    this.log('error', message, context);
  }
}

export const logger = new Logger();
